module.exports = __webpack_public_path__ + "static/crystalline_chronicle-10ad4bd635788180818d19a860205d8f.png";